export default __webpack_public_path__ + "css/adminSettings.bundle.css";